import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeStatusCron'
})
export class PipeStatusCron implements PipeTransform {
    constructor() {}
    transform(url) {
        if(url == 'Parado'){
            return 'callout callout-secondary';
        } else if(url == 'Iniciado'){
            return 'callout callout-warning';
        } else if(url == 'Concluido' || url == 'Concluído'){
            return 'callout callout-success';
        } else {
            return 'callout callout-danger';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeStatusCron.ts